import { AnyAction } from 'redux';
import {
    RESET_STATE, GET_PEOPLE_COUNT_IN_ROLE, GET_ROLE, GET_ROLES, GET_MORE_ROLES, GET_ROLES_MEMBER_COUNT, GET_MORE_ROLES_MEMBER_COUNT, ROLES_COUNT, GET_USERS_TO_ROLES,
    GET_GROUPS_COUNT_IN_ROLE, GET_GROUPS_TO_ROLES, ROLES_FOR_SELECT
} from '@app/store/constants';


const initialState = {
    role: {},
    roles: [],
    roleMemberCount: [],
    count: 0,
    peopleInRoleCount: 0,
    usersInRole: [],
    groupsInRoleCount: 0,
    groupsInRole: [],
    rolesForSelect: []
};

export function roles(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_ROLE:
            return {
                ...state,
                role: payload
            };
        case GET_ROLES:
            return {
                ...state,
                roles: payload.roles
            };
        case GET_MORE_ROLES:
            return {
                ...state,
                roles: [...state.roles, ...payload.roles]
            };
        case GET_ROLES_MEMBER_COUNT:
            return {
                ...state,
                roleMemberCount: payload
            };
        case GET_MORE_ROLES_MEMBER_COUNT:
            return {
                ...state,
                roleMemberCount: [...state.roleMemberCount, ...payload]
            };
        case ROLES_COUNT:
            return {
                ...state,
                count: payload
            };
        case GET_PEOPLE_COUNT_IN_ROLE:
            return {
                ...state,
                peopleInRoleCount: payload
            };
        case GET_USERS_TO_ROLES:
            return {
                ...state,
                usersInRole: payload
            };
        case GET_GROUPS_COUNT_IN_ROLE:
            return {
                ...state,
                groupsInRoleCount: payload
            };
        case GET_GROUPS_TO_ROLES:
            return {
                ...state,
                groupsInRole: payload
            };
        case ROLES_FOR_SELECT:
            return {
                ...state,
                rolesForSelect: payload
            };
        default:
            return state;
    }
}
